import React from 'react';

// Styles & Assets
import styles from './ToolbarPreconfigPage.module.css';
import { RiFilterFill } from 'react-icons/ri';

// Hooks
import { useTranslation } from 'react-i18next';

// Components
import Toolbar from '../../UI/Toolbar/Toolbar';
import Searchbar from '../../UI/Searchbar/Searchbar';
import ButtonToolbar from '../../UI/ButtonToolbar/ButtonToolbar';
import ButtonAdd from '../../UI/ButtonAdd/ButtonAdd';
import FilterPreconfigDialog from '../../PreconfigurationPage/FilterPreconfigDialog/FilterPreconfigDialog';

// Interfaces
interface Props{
    selectedPathologiesIDs: number[]
    selectedProfileIDs: number[]
    handleChangeSearchbar: (evt: React.ChangeEvent<HTMLInputElement>) => void
    handleConfirmFilters: (temporalIDs: number[], selectedProfileIDs: number[]) => void
}

const ToolbarPreconfigPage: React.FC<Props> = ({
    selectedPathologiesIDs,
    selectedProfileIDs,
    handleChangeSearchbar,
    handleConfirmFilters,
}) => {

    const { t } = useTranslation();

    return (
        <Toolbar text={t('administration')} link='/home/administration'>
            <div className={styles.toolbarPreconf}>
                <Searchbar handleChange={handleChangeSearchbar} />
                <ButtonToolbar
                    icon={<RiFilterFill />}
                    label={t('filter')}
                >
                    <FilterPreconfigDialog
                        modalShow={() => undefined}
                        setFilterBallActive={() => undefined}
                        defaultIDs={selectedPathologiesIDs}
                        defaultProfileIDs={selectedProfileIDs}
                        handleConfirm={handleConfirmFilters}
                    />
                </ButtonToolbar>
                <ButtonAdd
                    text={t('create_preconfiguration')}
                    link='create-preconfig' />
            </div>
        </Toolbar>
    );
};

export default ToolbarPreconfigPage;